<script>
	// NPM Modules
	import Link from 'svelte-navaid/Link.svelte';
	import { navigate } from 'svelte-navaid';
	// Components
	import Loading from '@/Components/Loading.svelte';
	import SelectInput from '@/Components/SelectInput.svelte';
	import Helmet from '@/Components/Helmet.svelte';
	// Partials
	import Sport from '@/Partials/Sport/Manage/_Sport.svelte';
	import CreateSport from '@/Partials/Sport/Manage/Sport/_Create.svelte';
	import Competitions from '@/Partials/Sport/Manage/_Competitions.svelte';
	import Events from '@/Partials/Sport/Manage/_Events.svelte';
	import MarketTypes from '@/Partials/Sport/Manage/_MarketTypes.svelte';
	import ParentMarkets from '@/Partials/Sport/Manage/_ParentMarkets.svelte';
	import MultiControl from '@/Partials/Sport/Manage/_MultiControl.svelte';
	import DerivedMarkets from '@/Partials/Sport/Manage/_DerivedMarkets.svelte';
	// Stores
	import ACLStore from '@/Stores/ACLStore.js';
	import SportStore from '@/Stores/Sport/SportStore';

	export let sportId = undefined;
	export let tab = undefined;
	export let subTab = undefined;

	let loading = SportStore.getSports(true);
	let showCreateManualSport = false;

	$: sportId = sportId && parseInt(sportId);
	$: selectedSport = sportId && $SportStore && $SportStore.where('id', parseInt(sportId)).first();
</script>

<Helmet title="Manage sports" />

{#if showCreateManualSport}
	<CreateSport bind:open={showCreateManualSport} />
{/if}

<div>
	{#await loading}
		<Loading />
	{:then}
		<div>
			<!-- Page Header -->
			<div class="flex flex-col items-center w-full p-4 mb-4 text-sm bg-white border-b md:py-2">
				<div class="flex items-center justify-between w-full">
					<div class="w-56">
						<h1 class="text-xl font-bold">Manage sports</h1>
					</div>
					<SelectInput
						className="py-1 w-1/3"
						name="sport"
						required={true}
						on:change={(e) => navigate(`/sport/manage/${e.target.value}`)}
						bind:value={sportId}
					>
						<option value={null}>Select Sport...</option>
						{#each $SportStore.sortBy('name').all() as sport (sport.id)}
							{#if parseInt(sport.id) === parseInt(sportId)}
								<option value={sport.id} selected>{sport.name}</option>
							{:else}
								<option value={sport.id}>{sport.name}</option>
							{/if}
						{/each}
					</SelectInput>
					<div class="w-56 text-right">
						{#if $ACLStore && ACLStore.granted('sports.create')}
							<button on:click={() => (showCreateManualSport = true)} class="btn btn-primary">
								Create manual sport
							</button>
						{/if}
					</div>
				</div>
			</div>
			<!-- /Page Header -->
			{#if selectedSport}
				<!-- Page Content -->
				<div class="p-2 mx-4 bg-gray-100 rounded">
					<!-- Sport tabs -->
					<div class="flex flex-row items-center justify-between w-full py-2">
						<div class="w-40 text-center">
							{#if selectedSport.is_manual}
								<div class="ml-4 px-2 py-1 bg-orange-500 rounded-md text-light">MANUAL SPORT</div>
							{/if}
						</div>
						<h1 class="text-2xl font-bold">{selectedSport.name}</h1>
						<div class="w-40" />
					</div>
					<div class="flex items-center justify-between">
						<div class="flex items-center justify-around w-full">
							<div class="flex-1 text-center">
								<div class="btn-group">
									<Link
										href={`/sport/manage/${selectedSport.id}`}
										class="btn {tab === undefined || tab === null ? 'btn-primary-action' : 'btn-muted text-dark'}"
									>
										Settings
									</Link>
									<Link
										href={`/sport/manage/${selectedSport.id}/competitions`}
										class="btn {tab === 'competitions' ? 'btn-primary-action' : 'btn-muted text-dark'}"
									>
										Competitions
									</Link>
									<Link
										href={`/sport/manage/${selectedSport.id}/events`}
										class="btn {tab === 'events' ? 'btn-primary-action' : 'btn-muted text-dark'}"
									>
										Events
									</Link>
									<Link
										href={`/sport/manage/${selectedSport.id}/market_types`}
										class="btn {tab === 'market_types' ? 'btn-primary-action' : 'btn-muted text-dark'}"
									>
										Market Types
									</Link>
									<Link
										href={`/sport/manage/${selectedSport.id}/parent_markets`}
										class="btn {tab === 'parent_markets' ? 'btn-primary-action' : 'btn-muted text-dark'}"
									>
										Parent Markets
									</Link>
									<Link
										href={`/sport/manage/${selectedSport.id}/multi`}
										class="btn {tab === 'multi' ? 'btn-primary-action' : 'btn-muted text-dark'}"
									>
										Multi Control
									</Link>
									<Link
										href={`/sport/manage/${selectedSport.id}/derived`}
										class="btn {tab === 'derived' ? 'btn-primary-action' : 'btn-muted text-dark'}"
									>
										Derived Markets
									</Link>
								</div>
							</div>
						</div>
					</div>
					<hr class="my-2" />
					{#if tab === undefined || tab === null}
						<Sport sport={selectedSport} />
					{:else if tab === 'competitions'}
						<Competitions sport={selectedSport} tab={subTab} />
					{:else if tab === 'events'}
						<Events sport={selectedSport} />
					{:else if tab === 'market_types'}
						<MarketTypes sport={selectedSport} />
					{:else if tab === 'parent_markets'}
						<ParentMarkets sport={selectedSport} />
					{:else if tab === 'multi'}
						<MultiControl sport={selectedSport} tab={subTab} />
					{:else if tab === 'derived'}
						<DerivedMarkets sport={selectedSport} tab={subTab} />
					{/if}
				</div>
				<!-- /Page Content -->
			{/if}
		</div>
	{/await}
</div>
